import React, { useState } from 'react';
import { Container, Row, Col } from "react-bootstrap";

const Career = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    experience: '',
    resume: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, resume: e.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    for (const key in formData) {
      formDataToSend.append(key, formData[key]);
    }
    // Replace with actual backend API endpoint
    fetch('/submit.php', {
      method: 'POST',
      body: formDataToSend,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log('Success:', data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  };
    return (
        <div>
        <section className="welcome-message section-padding">
        <Container className="contact-form">
        <Row>
            <Col lg={6} sm={12} className='mx-auto infor-di mi-gray d-flex flex-column p-4 career-form'>
      <h4 className="subtitle">Your Future Starts Here!</h4>
              <h2 className="title">Be a Part of Our Journey – We’re Hiring!</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3 form-group">
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3 form-group">
          <label htmlFor="phone" className="form-label">Phone Number</label>
          <input
            type="tel"
            className="form-control"
            id="phone"
            name="phone"
            placeholder="Enter your phone number"
            pattern="[0-9]{10}"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3 form-group">
          <label htmlFor="email" className="form-label">Email</label>
          <input
            type="email"
            className="form-control"
            id="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3 form-group">
          <label htmlFor="address" className="form-label">Address</label>
          <textarea
            className="form-control"
            id="address"
            name="address"
            rows="3"
            placeholder="Enter your address"
            value={formData.address}
            onChange={handleChange}
            required
          ></textarea>
        </div>

        <div className="mb-3 form-group">
          <label htmlFor="experience" className="form-label">Experience</label>
          <input
            type="text"
            className="form-control"
            id="experience"
            name="experience"
            placeholder="Enter your experience"
            value={formData.experience}
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3 form-group">
          <label htmlFor="resume" className="form-label">Upload Resume</label>
          <input
            type="file"
            className="form-control"
            id="resume"
            name="resume"
            accept=".pdf,.doc,.docx"
            onChange={handleFileChange}
            required
          />
          <div className="form-text">Accepted formats: .pdf, .doc, .docx</div>
        </div>

        <button type="submit" className="theme-btn mt-4">Submit Application</button>
      </form>
      </Col>
      </Row>
    </Container>
    </section>
    </div>
    );
}

export default Career;
